import { COLORS } from "layouts/ThemeProvider/palette";

export default {
  MuiFormHelperText: {
    root: {
      textAlign: "center",
      fontSize: 12,
      "&$error": {
        color: COLORS.havelockBlue,
      },
    },
  },
};
